import React from "react";
import Form from 'react-bootstrap/Form'

import './FormInputs.css'

//props.value, onchange from caller
export function IdInput (props) {
  let childProps ={
    ...props, id: "loginId", label:"Login ID", type: "text",
  }
  return GenericInput(childProps)
}

export function EmailInput (props) {
  let childProps = emailProps (props) 
  return GenericInput(childProps)
}
export function EmailBlankInput (props) {
  let childProps = emailProps(props)
  delete childProps.label
  return GenericInput(childProps)
}

function emailProps (props) {
  return {
    ...props, id: "email", label: "Email", type: "text", placeholder:'you@where.com'
  }
}
export function PasswordInput (props) {
  let childProps = {
    ...props, id: "password", label: "Password", type: "password", placeholder:'Password'
  }
  return GenericInput(childProps)
}

export function RepeatPasswordInput(props) {
  let childProps = {
    ...props, id: "confirmpassword", label: "Repeat that password", type:"password",
    placeholder: "Repeat password"
  }
  return GenericInput(childProps);
}

export function GenericInput (props) {
  const options = props?.options ?? {};
  return (
    <Form.Group id={props.id} className="mb-3">
      {props.label ? <Form.Label className="formLabel">{props.label}</Form.Label> : null}
      <Form.Control className="formField" {...props} {...options} />
    </Form.Group>
  )
}
